import { ReactNode } from 'react';
import { DataTestId } from 'core/common/constants';
import { Button, Image, Stack, Typography } from 'core/common/ui/ui-kit';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { CaptionStyled } from './styled';

type PaymentErrorLayoutProps = {
  image: { src: string; alt: string };
  title: string;
  descriptions: string[];
  caption: ReactNode;
  button: string;
  expressButton?: ReactNode;
  onTryAgain: () => void;
};

export const PaymentErrorLayout = ({
  image,
  title,
  descriptions,
  caption,
  button,
  expressButton,
  onTryAgain,
}: PaymentErrorLayoutProps) => {
  return (
    <Stack alignItems="center" gap={2} data-testid={DataTestId.PAYMENT_ERROR_MODAL}>
      <Image width={64} height={64} src={image.src} alt={image.alt} />
      <Stack width="100%" gap={4}>
        <Stack gap={2}>
          <Typography variant="text-heading-2xl" dangerouslySetInnerHTML={prepareHtml(title)} />
          {descriptions.map((description, index) => (
            <Typography
              key={`${index}-${description}`}
              variant="text-body-sm"
              color="text.subtitle"
              dangerouslySetInnerHTML={prepareHtml(description)}
            />
          ))}
        </Stack>
        <CaptionStyled variant="text-body-xs">{caption}</CaptionStyled>
      </Stack>
      <Stack width="100%" gap={2} mt={13} pb={2}>
        {expressButton}
        <Button
          fullWidth
          variant="contained"
          data-testid={DataTestId.PAYMENT_ERROR_BUTTON}
          onClick={onTryAgain}
        >
          {button}
        </Button>
      </Stack>
    </Stack>
  );
};
